function toElementVisual(ref) {
  if (!ref) return void 0;
  if (ref.element instanceof HTMLElement) {
    return {
      ...ref,
      className: ref.styles || ""
    };
  }
  return void 0;
}
export {
  toElementVisual
};
//# sourceMappingURL=toElementVisual.js.map
